<template>
  <div class="wlx-basic-static-wrapper">
    <div class="basic-head-main" :style="{backgroundImage:'url('+headBg+')'}">
      <div class="basic-head-con">
        <!-- <div class="head-logo-con">
          <img src="~assets/images/wlx-basic-logo.png" alt class="logo-img-val">
        </div>-->
        <div class="head-title-con clearfix">
          <div class="fl">
            <img src="~assets/images/basic-book-img.png" alt>
          </div>
          <div class="fr head-title-word">
            <p class="p-title-1">物流管理1+X试点扩容院校</p>
            <p class="p-title-1">基本情况统计表</p>
            <!-- <p class="p-title-2 p-title-2-1">为了使贵校更快的成为试点学校，请您如实认真填写基本情况统计表，感谢您的配合。</p> -->
            <p class="p-title-2 p-title-2-1">——北京中物联物流采购培训中心</p>
          </div>
        </div>
      </div>
    </div>
    <div class="basic-form-main">
      <div class="basic-form-con">
        <div class="form-label-title">学校信息</div>
        <div class="form-info-content clearfix">
          <div class="form-info-con clearfix">
            <div class="clearfix form-info-li">
              <span class="sp-form-label fl">学校名称</span>
              <div class="fr form-input-con">
                <el-input size="small" v-model="schoolName" disabled></el-input>
              </div>
            </div>
            <div class="clearfix form-info-li">
              <span class="sp-form-label fl">学校层次</span>
              <div class="fr form-input-con"> 
                <el-select placeholder="请选择学校层次" size="small" v-model="schoolArrange" disabled>
                  <el-option label="中职" :value="1"></el-option>
                  <el-option label="高职" :value="2"></el-option>
                  <el-option label="本科" :value="3"></el-option>
                </el-select>
              </div>
            </div>
            <div class="clearfix form-info-li">
              <span class="sp-form-label fl">学校类型</span>
              <div class="fr form-input-con">
                <el-select placeholder="请选择学校类型" size="small" v-model="schoolType" disabled>
                  <el-option label="国示范" :value="1"></el-option>
                  <el-option label="省示范" :value="2"></el-option>
                  <el-option label="行业特色校" :value="3"></el-option>
                  <el-option label="优质校" :value="4"></el-option>
                  <el-option label="本科" :value="5"></el-option>
                </el-select>
                <!-- <el-input size="small" v-model="schoolType" disabled></el-input> -->
              </div>
            </div>
            <div class="clearfix form-info-li">
              <span class="sp-form-label fl">省份</span>
              <div class="fr form-input-con">
                <el-input size="small" v-model="province" disabled></el-input>
              </div>
            </div>
            <div class="clearfix form-info-li">
              <span class="sp-form-label fl">学校地址</span>
              <div class="fr form-input-con">
                <el-input size="small" v-model="schoolAddress" disabled></el-input>
              </div>
            </div>
            <div class="clearfix form-info-li">
              <span class="sp-form-label fl">学校邮编</span>
              <div class="fr form-input-con">
                <el-input size="small" v-model="schoolEmail" disabled></el-input>
              </div>
            </div>
          </div>
        </div>
        <div class="form-label-title">试点负责人信息</div>
        <div class="form-info-content clearfix">
          <div class="form-info-con clearfix">
            <div class="clearfix form-info-li">
              <span class="sp-form-label fl">负责人姓名</span>
              <div class="fr form-input-con">
                <el-input size="small" v-model="personInfo" disabled></el-input>
              </div>
            </div>
            <div class="clearfix form-info-li">
              <span class="sp-form-label fl">负责人职务</span>
              <div class="fr form-input-con">
                <el-select placeholder="请选择负责人职务" size="small" v-model="personPost" disabled>
                  <el-option label=" " :value="0"></el-option>
                  <el-option label="校领导" :value="1"></el-option>
                  <el-option label="院系领导" :value="2"></el-option>
                  <el-option label="专业负责人" :value="3"></el-option>
                  <el-option label="其他" :value="4"></el-option>
                </el-select>
                <!-- <el-input size="small" v-model="personPost" disabled></el-input> -->
              </div>
            </div>
            <div class="clearfix form-info-li">
              <span class="sp-form-label fl">负责人手机</span>
              <div class="fr form-input-con">
                <el-input size="small" v-model="personPhone" disabled></el-input>
              </div>
            </div>
          </div>
        </div>
        <div class="form-label-title">参与证书信息</div>
        <div class="form-info-content clearfix">
          <div class="form-info-con clearfix">
            <div class="clearfix form-info-li">
              <span class="sp-form-label fl">证书名称</span>
              <div class="fr form-input-con">
                <el-input size="small" v-model="certifyName" disabled></el-input>
              </div>
            </div>
            <div class="clearfix form-info-li">
              <span class="sp-form-label fl">证书等级</span>
              <div class="fr form-input-con">
                <el-select placeholder="请选择证书等级" size="small" v-model="cerfityGrade" disabled>
                  <el-option label="初级" :value="1"></el-option>
                  <el-option label="中级" :value="2"></el-option>
                  <el-option label="高级" :value="3"></el-option>
                </el-select>
                <!-- <el-input size="small" v-model="cerfityGrade" disabled></el-input> -->
              </div>
            </div>
            <div class="clearfix form-info-li">
              <el-table :data="tableData3" style="width: 100%" size="small" class="form-table-con">
                <el-table-column prop="marjorName" label="对应专业" align="center"></el-table-column>
                <el-table-column label="近三年招生人数" align="center">
                  <el-table-column prop="totalPersonNum" label="总人数" align="center"></el-table-column>
                  <el-table-column prop="year1" label="2016年" align="center"></el-table-column>
                  <el-table-column prop="year2" label="2017年" align="center"></el-table-column>
                  <el-table-column prop="year3" label="2018年" align="center"></el-table-column>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
        <div class="form-label-title">培训团队专业带头人信息</div>
        <div class="form-info-content clearfix">
          <div class="form-info-con clearfix">
            <div class="clearfix form-info-li">
              <span class="sp-form-label fl">姓名</span>
              <div class="fr form-input-con">
                <el-input size="small" v-model="leaderName" disabled></el-input>
              </div>
            </div>
            <div class="clearfix form-info-li">
              <span class="sp-form-label fl">职务</span>
              <div class="fr form-input-con">
                <el-input size="small" v-model="leaderPost" disabled></el-input>
              </div>
            </div>
            <div class="clearfix form-info-li">
              <span class="sp-form-label fl">专业</span>
              <div class="fr form-input-con">
                <el-input size="small" v-model="leaderMajor" disabled></el-input>
              </div>
            </div>
            <div class="clearfix form-info-li">
              <span class="sp-form-label fl">职称</span>
              <div class="fr form-input-con">
                <el-input size="small" v-model="leaderTitle" disabled></el-input>
              </div>
            </div>
          </div>
        </div>
        <div class="form-label-title">培训团队师资信息</div>
        <div class="form-info-content clearfix">
          <div class="form-info-con clearfix">
            <div class="clearfix form-info-li">
              <span class="sp-form-label fl">团队总人数</span>
              <div class="fr form-input-con">
                <el-input size="small" v-model="teamPersonNum" disabled></el-input>
              </div>
            </div>
            <div class="clearfix form-info-li">
              <span class="sp-form-label fl">高级职称人数</span>
              <div class="fr form-input-con">
                <el-input size="small" v-model="seniorNum" disabled></el-input>
              </div>
            </div>
            <div class="clearfix form-info-li">
              <span class="sp-form-label fl">行业企业专家人数</span>
              <div class="fr form-input-con">
                <el-input size="small" v-model="expertNum" disabled></el-input>
              </div>
            </div>
            <div class="clearfix form-info-li">
              <span class="sp-form-label fl">学校专业教师人数</span>
              <div class="fr form-input-con">
                <el-input size="small" v-model="teaNum" disabled></el-input>
              </div>
            </div>
            <div class="clearfix form-info-li">
              <span class="sp-form-label fl">专职教学管理团队人数</span>
              <div class="fr form-input-con">
                <el-input size="small" v-model="teachTeamNun" disabled></el-input>
              </div>
            </div>
            <div class="clearfix form-info-li">
              <span class="sp-form-label fl">技术服务团队人数</span>
              <div class="fr form-input-con">
                <el-input size="small" v-model="technologyTeamNum" disabled></el-input>
              </div>
            </div>
          </div>
        </div>
        <div class="form-label-title">培训场地建设信息</div>
        <div class="form-info-content clearfix">
          <div class="form-info-con clearfix">
            <div class="clearfix form-info-li">
              <span class="sp-form-label fl">场地地址</span>
              <div class="fr form-input-con">
                <el-input size="small" v-model="address" disabled></el-input>
              </div>
            </div>
            <div class="clearfix form-info-li">
              <span class="sp-form-label fl">场地面积（平米）</span>
              <div class="fr form-input-con">
                <el-input size="small" v-model="teachArea" disabled></el-input>
              </div>
            </div>
            <div class="clearfix form-info-li">
              <span class="sp-form-label fl">可容纳理论学习人数</span>
              <div class="fr form-input-con">
                <el-input size="small" v-model="stuNum" disabled></el-input>
              </div>
            </div>
            <div class="clearfix form-info-li">
              <span class="sp-form-label fl">可容纳实践操作人数</span>
              <div class="fr form-input-con">
                <el-input size="small" v-model="operateNum" disabled></el-input>
              </div>
            </div>
          </div>
        </div>
        <div class="form-label-title">近三年完成取证类培训信息</div>
        <div class="form-info-content clearfix">
          <div class="form-info-con clearfix">
            <div class="clearfix form-info-li">
              <el-table
                :data="trainData"
                border
                style="width: 100%;"
                size="small"
                class="form-table-con"
                show-summary
                sum-text="总人数"
              >
                <el-table-column prop="trainGradeName" label="培训班名称" align="center"></el-table-column>
                <el-table-column prop="trainNum" label="培训人数" align="center"></el-table-column>
              </el-table>
            </div>
          </div>
        </div>
        <div class="form-label-title">课程体系建设基本信息</div>
        <div class="form-info-content clearfix">
          <div class="form-info-con clearfix">
            <div class="clearfix form-info-li">
              <el-input type="textarea" v-model="courseBasicInfo" rows="7" disabled></el-input>
            </div>
          </div>
        </div>
        <div class="form-label-title">实训设备设施基本信息</div>
        <div class="form-info-content clearfix">
          <div class="form-info-con clearfix">
            <div class="clearfix form-info-li">
              <el-input type="textarea" v-model="equipmentInfo" rows="7" disabled></el-input>
            </div>
          </div>
        </div>
        <div class="form-label-title">管理制度和保障条件基本信息</div>
        <div class="form-info-content clearfix">
          <div class="form-info-con">
            <div class="clearfix form-info-li">
              <el-input type="textarea" v-model="managerInfo" rows="7" disabled></el-input>
            </div>
          </div>
        </div>
        <div class="submit-btn-con">
          <el-button size="small" type="primary" @click="submitData">关闭</el-button>
          <el-button size="small" type="primary" @click="delateData">删除</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      headBg: require("assets/images/wlx-baic-bg-img.png"),
      schoolName: "",
      schoolArrange: "",
      schoolType: "",
      personInfo: "",
      personPhone: "",
      personPost: "",
      certifyName: "物流管理",
      cerfityGrade: "",
      tableData3: [],
      leaderName: "",
      leaderPost: "",
      leaderTitle: "",
      leaderMajor: "",
      teamPersonNum: "",
      seniorNum: "",
      expertNum: "",
      teaNum: "",
      teachTeamNun: "",
      technologyTeamNum: "",
      address: "",
      teachArea: "",
      stuNum: "",
      operateNum: "",
      trainData: [],
      courseBasicInfo: "",
      equipmentInfo: "",
      managerInfo: "",
      trainTotalNum: 0,
      questionnaireInfo: {},
      schoolAddress: "",
      schoolEmail: "",
      province: ""
    };
  },
  props: {
    Id: {
      type: String,
      default: ""
    }
  },
  watch: {},
  created() {
    this.getQuestionnaireInfo();
  },
  methods: {
    submitData() {
      this.$router.push({
        name: "pilotManager"
      });
    },
    delateData() {
      var that = this;
      this.$confirm("此操作将删除该申报信息, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$http
            .post("/api/XOrg/QuestionnaireManager/deleteNaire", {
              id: that.Id
            })
            .then(rst => {
              if (rst.code > 0) {
                that.$message({
                  type: "success",
                  message: "删除成功!"
                });
                that.$router.push({
                  name: "pilotManager"
                });
              } else {
                that.$message.error("删除失败!");
              }
            });
        }).catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    //获取调查表详情
    getQuestionnaireInfo() {
      var that = this;
      this.$http
        .post("/api/XOrg/QuestionnaireManager/getQuestionnaireInfo", {
          id: that.Id
        })
        .then(rst => {
          if (rst.code > 0) {
            this.schoolName = rst.questionnaire.SchoolName;
            this.schoolArrange = rst.questionnaire.SchoolLevel;
            this.schoolType = rst.questionnaire.SchoolType;
            this.personInfo = rst.questionnaire.ResponNameOrJob;
            this.personPhone = rst.questionnaire.Phone;
            this.certifyName = rst.questionnaire.Certificate;
            this.personPost = rst.questionnaire.Job;
            this.cerfityGrade = rst.questionnaire.CertificateLeavel;
            this.tableData3 = JSON.parse(rst.questionnaire.Major);
            this.leaderName = rst.questionnaire.TeaTeamName;
            this.leaderPost = rst.questionnaire.TeaTeamJob;
            this.leaderTitle = rst.questionnaire.TeaTeamTitle;
            this.leaderMajor = rst.questionnaire.TeaTeamMajor;
            this.teamPersonNum = rst.questionnaire.PersonCount;
            this.seniorNum = rst.questionnaire.SeniorCount;
            this.expertNum = rst.questionnaire.XpertCount;
            this.teaNum = rst.questionnaire.TeaCount;
            this.teachTeamNun = rst.questionnaire.TeachingCount;
            this.technologyTeamNum = rst.questionnaire.SkillCount;
            this.address = rst.questionnaire.Address;
            this.teachArea = rst.questionnaire.Area;
            this.stuNum = rst.questionnaire.StudyCount;
            this.operateNum = rst.questionnaire.TrainCount;
            this.trainData = JSON.parse(rst.questionnaire.TrainSituation);
            this.trainTotalNum = rst.questionnaire.TrainSituationCount;
            this.courseBasicInfo = rst.questionnaire.CourseBuildContent;
            this.equipmentInfo = rst.questionnaire.DeviceImpleContent;
            this.managerInfo = rst.questionnaire.ManagerContent;
            this.schoolAddress = rst.questionnaire.SchoolAddress;
            this.schoolEmail = rst.questionnaire.SchoolEmail;
            this.province = rst.questionnaire.Province;
          }
        });
    }
  }
};
</script>

<style lang="scss">
.wlx-basic-static-wrapper {
  // height: 100%;
  background: #f0f6ff;
  overflow: auto;
  .basic-head-main {
    height: 706px;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center top;
    .basic-head-con {
      margin: 0 auto;
      width: 1000px;
    }
    .head-logo-con {
      padding: 26px 0 0 26px;
    }
    .logo-img-val {
      height: 40px;
    }
    .head-title-con {
      position: relative;
      // margin-top: 40px;
    }
    .head-title-word {
      position: absolute;
      right: 0;
      top: 70px;
      z-index: 100;
      color: #fff;
    }
    .p-title-1 {
      font-size: 68px;
      font-weight: bold;
      text-align: center;
    }
    .p-title-2-1 {
      margin-top: 50px;
      text-align: right;
      font-size: 20px;
    }
    // .p-title-2 {
    //   margin-top: 10px;
    //   text-align: right;
    // }
  }
  .basic-form-main {
    margin: 0 auto;
    margin-top: -325px;
    padding: 20px 0;
    width: 1000px;
    background: #fff;
  }
  .basic-form-con {
    margin: 0 20px;
    padding: 20px;
    background: #f0f0f0;
    min-height: 400px;
    .form-label-title {
      margin-bottom: 20px;
      padding-bottom: 12px;
      color: #0155d1;
      font-size: 24px;
      border-bottom: 1px solid #cccccc;
    }
    .form-info-li {
      margin: 15px 0;
      .el-input.is-disabled .el-input__inner{
        color: #666;
      }
    }
    .form-info-con {
      float: right;
      width: 740px;
    }
    .form-input-con {
      .el-input {
        width: 420px;
      }
    }
    .sp-form-label {
      margin-top: 4px;
      font-size: 16px;
    }
    .form-table-con {
      .el-input {
        .el-input__inner {
          border: none;
        }
      }
    }
    .add-table-tr-btn {
      padding: 10px 0;
      text-align: center;
      color: #0155d1;
      font-size: 16px;
      background: #fff;
      i {
        margin-right: 10px;
      }
    }
  }
  .submit-btn-con {
    padding: 20px 0;
    text-align: center;
  }
}
</style>
